import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({ baseURL: API_URL });

// Attach JWT
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
  createUser: (data) => api.post('/auth/users', data),
};

export const playersAPI = {
  getAll: (params) => api.get('/players', { params }),
  getOne: (id) => api.get(`/players/${id}`),
  create: (data) => api.post('/players', data),
  update: (id, data) => api.put(`/players/${id}`, data),
  delete: (id) => api.delete(`/players/${id}`),
};

export const tournamentsAPI = {
  getAll: (params) => api.get('/tournaments', { params }),
  getOne: (id) => api.get(`/tournaments/${id}`),
  create: (data) => api.post('/tournaments', data),
  update: (id, data) => api.put(`/tournaments/${id}`, data),
  delete: (id) => api.delete(`/tournaments/${id}`),
};

export const rankingsAPI = {
  getLeaderboard: (params) => api.get('/leaderboard', { params }),
  recalculate: (params) => api.post('/rankings/recalculate', {}, { params }),
};

export const participationsAPI = {
  getAll: (params) => api.get('/participations', { params }),
  add: (data) => api.post('/participations', data),
  update: (id, data) => api.put(`/participations/${id}`, data),
  delete: (id) => api.delete(`/participations/${id}`),
};

export const eventsAPI = {
  getAll: (params) => api.get('/events', { params }),
};
export const statsAPI = {
  dashboard: () => api.get('/dashboard'),
  sports: () => api.get('/sports'),
  countries: () => api.get('/countries'),
  clubs: () => api.get('/clubs'),
  pointRules: () => api.get('/point-rules'),
  updatePointRule: (id, data) => api.put(`/point-rules/${id}`, data),
};

export default api;
